// Slug helpers shared between client routes and the sitemap generator.

export function slugify(input: string | null | undefined): string {
  if (!input) return '';
  return input
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function setPath(set: { code: string; name: string }): string {
  return `/sets/${slugify(set.name)}-${set.code.toLowerCase()}`;
}

/** Recover a set code from the slug (suffix after the last `-`). */
export function setCodeFromSlug(slug: string): string {
  const m = slug.match(/-([a-z0-9]+)$/i);
  return (m ? m[1] : slug).toLowerCase();
}
